(() => {
  const enablePreselection = window.section?.enable_preselection;

  const productVariantsParent = document.querySelector(".js-product-variants-parent");
  const firstGridImage = document.querySelector(".product-media-gallery__grid-image1 img");
  const productImagesJson = document.getElementById("product-images-json");

  function normalizeSrc(src) {
    return src.split("?")[0]; 
  }

  function switchImage(newImage) {
    if (firstGridImage) {
      firstGridImage.src = newImage.src;
      firstGridImage.srcset = newImage.srcset || "";
    }
  }

  function getDynamicGalleryContainer() {
    return document.querySelector("[class^='product-media-gallery__grid-layout']");
  }

  function toggleDuplicateImages() {
    const galleryContainer = getDynamicGalleryContainer(); // Dynamically select the gallery container
    if (!galleryContainer) return;

    const galleryImages = galleryContainer.querySelectorAll("img");
    const uniqueImages = new Set();

    galleryImages.forEach((img) => {
      const normalizedSrc = normalizeSrc(img.src);

      if (uniqueImages.has(normalizedSrc)) {
        // Hide duplicates
        img.closest(".product-media-gallery__grid-image").style.display = "none";
      } else {
        // Show unique images
        img.closest(".product-media-gallery__grid-image").style.display = "";
        uniqueImages.add(normalizedSrc);
      }
    });
  }

  function updateGallery(images) {
    const galleryContainer = getDynamicGalleryContainer();
    const swiperContainer = document.querySelector(".product-media-gallery--mobile .product-media-gallery__swiper-wrapper");

    if (!galleryContainer || !swiperContainer) return;

    galleryContainer.innerHTML = "";
    swiperContainer.innerHTML = "";

    const uniqueImages = new Set();

    images.forEach((image, index) => {
      const normalizedSrc = normalizeSrc(image.src);
      if (!uniqueImages.has(normalizedSrc)) {
        uniqueImages.add(normalizedSrc);

        const desktopImage = `
          <div data-alt="${image.alt || ""}" class="product-media-gallery__grid-image${index + 1} js-product-media-gallery__grid-image product-media-gallery__grid-image">
            <img src="${image.src}" alt="${image.alt || ""}" loading="eager" class="cover">
          </div>
        `;
        galleryContainer.innerHTML += desktopImage;

        const mobileImage = `
          <div class="product-media-gallery__swiper-slide swiper-slide js-product-media-gallery__swiper-slide" data-swiper-slide-index="${index}">
            <img src="${image.src}" alt="${image.alt || ""}" loading="eager">
          </div>
        `;
        swiperContainer.innerHTML += mobileImage;
      }
    });
    toggleDuplicateImages();
  }

  function handleVariantSwitch(e) {
    const checkedInput = e.target;
    if (checkedInput.checked) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const jsonContent = scriptElement.textContent;
        const parsedData = JSON.parse(jsonContent);
        if (parsedData?.featured_image) {
          switchImage(parsedData.featured_image);
        }
        if (parsedData?.images) {
          updateGallery(parsedData.images);
        }
      }
    }
    toggleDuplicateImages();
  }

  function initializeDefaultVariant() {
    const productImages = productImagesJson ? JSON.parse(productImagesJson.textContent) : null;

    if (enablePreselection && productVariantsParent) {
      const checkedInput = productVariantsParent.querySelector("input[type='radio']:checked");
      if (checkedInput) {
        const scriptElement = document.querySelector(
          `script[type="application/json"][data-resource="${checkedInput.id}"]`
        );
        if (scriptElement) {
          const jsonContent = scriptElement.textContent;
          const parsedData = JSON.parse(jsonContent);
          if (parsedData?.featured_image) {
            switchImage(parsedData.featured_image);
          }
          if (parsedData?.images) {
            updateGallery(parsedData.images);
          }
        }
      }
    } else if (productImages?.images) {
      updateGallery(productImages.images);
      if (productImages?.featured_image) {
        switchImage(productImages.featured_image);
      }
    }
  }

  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      handleVariantSwitch(event);
    });

    initializeDefaultVariant();
    setTimeout(toggleDuplicateImages, 100);
  }
})();
